<div class="card" *ngIf="invoiceForm" [formGroup]="invoiceForm">
  <div class="card-header">
    <h2 class="card-title">{{ 'INVOICE_DOCUMENTS' | translate }}</h2>
  </div>
  <div class="card-body row" id="invoice-document">
    <div class="col-lg-12 col-12 d-flex align-items-center justify-content-between">
      <div id="attachment-uploader" class="custom-file mr-3">
        <input class="custom-file-input" type="file" lang="it" id="attachment" [multiple]="true" (change)="addAttachmentToList($any($event).target.files)" accept="application/pdf" />
        <label class="custom-file-label">{{ "SELECT_FILE" | translate }}</label>
      </div>
      <div *ngIf="attachments_list_obj.length > 0">
        <button class="btn btn-outline-danger" (click)="resetAttachmentsList()">{{ "RESET" | translate }}</button>
      </div>
    </div>
    <div class="col-lg-6 col-12 pt-2 d-flex align-items-center" *ngIf="existingAttachments.length > 0">
      <div *ngFor="let file of existingAttachments" class="d-flex h-fit mr-3">
        <div class="badge badge-light-success cursor-pointer" (click)="_utilsService.getFile(file.url)">
          <i [data-feather]="'file-text'" size="16" class="d-inline-block mr-025"></i>
          <span>{{ file.filename }}</span>
        </div>
        <div has_capability="delete_invoice_order" class="cursor-pointer text-danger ml-05" (click)="deleteFile(file)">
          <i [data-feather]="'trash-2'" size="16"></i>
        </div>
      </div>
    </div>
    <div class="col-12 row mt-2" *ngIf="attachments_list_obj.length > 0">
      <div *ngFor="let file of attachments_list_obj; let i = index" class="border-bottom mb-1 pb-1 col-12" [ngClass]="{'d-none': attachments_list_obj.length<1, 'd-flex': attachments_list_obj.length}">
        <div class="flex-basis-80 d-flex align-items-center">
          <div class="mr-05 cursor-pointer" (click)="removeAttachmentFromList(i)" *ngIf="file.status === 0">
            <i [data-feather]="'x'" class="text-danger" size="18"></i>
          </div>
          <div class="mt-025">{{ file.name }}</div>
        </div>
        <div class="flex-basis-20 text-right">{{ file.size }}</div>
      </div>
    </div>
    <div class="col-12 mt-2" *ngIf="attachments_list_obj.length + existingAttachments.length > 0; else noItems">{{ "TOTAL" | translate }}: {{ attachments_list_obj.length + existingAttachments.length }}</div>
    <ng-template #noItems>
      <div class="mt-2 col-12">{{ "NO__ORDER_ATTACHMENTS_SELECTED" | translate }}</div>
    </ng-template>
  </div>
</div>